<mat-select [formControl]="form" (selectionChange)="onChange()" [disabled]="!isActive[1]">
  <mat-select-trigger class="inner">
    <mat-icon
      [svgIcon]="selected.icon"
      [attr.data-key]="selected.key"
    ></mat-icon
    ><span>{{ form.value }}</span>
  </mat-select-trigger>
  <mat-option *ngFor="let option of options" [value]="option.value">
    <mat-icon [svgIcon]="option.icon" [attr.data-key]="option.key"></mat-icon
    ><span>{{ option.value }}</span>
  </mat-option>
</mat-select>
